/**
 * This is based on the original svg path with the svg props stripped out.
 * @returns {React.ReactNode} The smoke svg icon.
 */
export function SmokeSVGPath() {
    return (
        <g id="Smoke">
            <path d="M36.4 84 c-0.3 0 -0.5 -0.1 -0.7 -0.2 c-8.8 -3.7 -15.8 -10.7 -19.5 -19.5 c-0.4 -1 0 -2.1 1 -2.5 c1 -0.4 2.1 0 2.5 1 C23 70.8 29.2 77 37.1 80.4 c0.9 0.4 1.3 1.6 0.9 2.5 C37.7 83.6 37.1 84 36.4 84 z" />
            <path d="M41.2 72.7 c-0.3 0 -0.5 0 -0.7 -0.1 c-5.8 -2.5 -10.5 -7.2 -13 -13 c-0.4 -1 0 -2.1 1 -2.5 s2.1 0 2.5 1 c2.1 4.9 6.1 8.9 11 11 c1 0.4 1.4 1.5 1 2.5 C42.6 72.3 42 72.7 41.2 72.7 L41.2 72.7 z" />
            <path d="M63.6 84 c-1 0 -1.9 -0.8 -1.9 -1.9 c0 -0.8 0.5 -1.5 1.2 -1.8 C70.8 77 77 70.7 80.4 62.9 c0.4 -1 1.5 -1.4 2.5 -1 c1 0.4 1.4 1.5 1 2.5 l0 0 c-3.8 8.8 -10.8 15.8 -19.5 19.5 C64.1 84 63.9 84 63.6 84 z" />
            <path d="M58.8 72.7 c-1 0 -1.9 -0.8 -1.9 -1.9 c0 -0.8 0.5 -1.5 1.2 -1.8 c4.9 -2.1 8.9 -6.1 11 -11 c0.4 -1 1.5 -1.4 2.5 -1 c1 0.4 1.4 1.5 1 2.5 c-2.5 5.8 -7.2 10.5 -13 13 C59.3 72.7 59.1 72.7 58.8 72.7 z" />
            <path d="M82.2 38.3 c-0.8 0 -1.4 -0.5 -1.7 -1.2 C77 29.2 70.8 23 62.9 19.6 c-1 -0.4 -1.4 -1.5 -1 -2.5 c0.4 -1 1.5 -1.4 2.5 -1 c8.8 3.8 15.8 10.8 19.5 19.5 c0.4 1 0 2.1 -1 2.5 c0 0 0 0 0 0 C82.7 38.2 82.4 38.3 82.2 38.3 z" />
            <path d="M70.9 43 c-0.8 0 -1.4 -0.5 -1.7 -1.2 c-2.1 -4.9 -6.1 -8.9 -11 -11 c-1 -0.4 -1.4 -1.5 -1 -2.5 s1.5 -1.4 2.5 -1 c5.8 2.5 10.5 7.2 13 13 c0.4 1 0 2.1 -1 2.5 C71.4 43 71.1 43.1 70.9 43 z" />
            <path d="M29.1 43 c-0.3 0 -0.5 0 -0.7 -0.2 c-1 -0.4 -1.4 -1.5 -1 -2.5 c2.5 -5.8 7.2 -10.5 13 -13 c1 -0.4 2.1 0.1 2.4 1.1 c0.4 0.9 -0.1 2 -1 2.4 c-4.9 2.1 -8.9 6.1 -11 11 C30.6 42.6 29.9 43.1 29.1 43 z" />
            <path d="M17.9 38.3 c-0.3 0 -0.5 -0.1 -0.7 -0.2 c-1 -0.4 -1.4 -1.5 -1 -2.5 c0 0 0 0 0 0 c3.8 -8.8 10.8 -15.8 19.5 -19.5 c1 -0.4 2.1 0 2.5 1 c0.4 1 0 2.1 -1 2.5 C29.2 23 23 29.2 19.6 37.1 C19.3 37.8 18.6 38.3 17.9 38.3 z" />
            <path d="M50 63.2 c-7.3 0 -13.2 -5.9 -13.2 -13.2 c0 -7.3 5.9 -13.2 13.2 -13.2 c7.3 0 13.2 5.9 13.2 13.2 c0 0 0 0 0 0 C63.2 57.3 57.3 63.2 50 63.2 z M50 40.6 c-5.2 0 -9.4 4.2 -9.4 9.4 s4.2 9.4 9.4 9.4 s9.4 -4.2 9.4 -9.4 C59.4 44.8 55.2 40.6 50 40.6 z" />
            <path d="M50 99.1 c-27.1 0 -49.1 -22 -49.1 -49.1 c0 -27.1 22 -49.1 49.1 -49.1 c27.1 0 49.1 22 49.1 49.1 c0 0 0 0 0 0 C99 77.1 77.1 99 50 99.1 z M50 4.7 C25 4.7 4.7 25 4.7 50 S25 95.3 50 95.3 S95.3 75 95.3 50 C95.3 25 75 4.7 50 4.7 z" />
        </g>
    );
}

export function GasSVGPath() {
    return (
        <g id="Gas">
            <path d="M49.5 98.7 c-20.7 0 -37.4 -16.8 -37.4 -37.4 c0 -20.1 34.6 -58.4 36.1 -60 c0.7 -0.8 1.9 -0.8 2.7 -0.1 c0 0 0 0 0.1 0.1 c1.4 1.6 36 39.8 36 59.9 C87 81.9 70.2 98.7 49.5 98.7 z M49.5 5.4 C43 12.8 15.8 44.7 15.8 61.2 c-0.3 18.6 14.5 34 33.1 34.3 s34 -14.5 34.3 -33.1 c0 -0.4 0 -0.8 0 -1.2 C83.2 44.7 56 12.8 49.5 5.4 z" />
            <path d="M49.5 98.7 c-10.9 0 -19.7 -8.8 -19.7 -19.7 c0 -10.2 16.4 -28.6 18.3 -30.6 c0.7 -0.8 2 -0.8 2.7 0 l0 0 c1.9 2 18.3 20.4 18.3 30.6 c0 1 -0.8 1.9 -1.9 1.9 c-1 0 -1.9 -0.8 -1.9 -1.9 l0 0 c0 -6.8 -10.5 -20.2 -15.9 -26.5 C44 58.8 33.6 72.2 33.6 79 c0 8.8 7.1 16 15.9 16 l0 0 c1 0 1.9 0.8 1.9 1.9 C51.4 97.9 50.5 98.7 49.5 98.7 L49.5 98.7 L49.5 98.7 z" />
        </g>
    );
}

export function ElectricalSVGPath() {
    return (
        <g id="Electrical">
            <path d="M50.5 98.7 c-27.1 0 -49.1 -22 -49.1 -49.1 s22 -49.1 49.1 -49.1 s49.1 22 49.1 49.1 l0 0 C99.5 76.7 77.6 98.6 50.5 98.7 z M50.5 4.3 c-25 0 -45.3 20.3 -45.3 45.3 s20.3 45.3 45.3 45.3 s45.3 -20.3 45.3 -45.3 S75.5 4.3 50.5 4.3 z" />
            <path d="M39.2,53.5c-0.4,0-0.7-0.1-1-0.3c-0.9-0.6-1.1-1.7-0.6-2.6l16.7-26.1c0.5-0.9,1.6-1.3,2.5-0.8s1.3,1.6,0.8,2.5,c0,0.1-0.1,0.2-0.2,0.3L40.8,52.7C40.4,53.2,39.8,53.5,39.2,53.5 z" />
            <path d="M45.8,75.5c-1,0-1.9-0.8-1.9-1.9c0-0.4,0.1-0.7,0.3-1L61,46.5c0.5-0.9,1.6-1.3,2.5-0.8,c0.9,0.5,1.3,1.6,0.8,2.5c0,0.1-0.1,0.2-0.2,0.3L47.4,74.7C47,75.2,46.4,75.5,45.8,75.5 z" />
            <path d="M39.2,53.5c-1,0-1.9-0.9-1.9-1.9c0-0.9,0.7-1.7,1.6-1.9l23.3-4.1c1-0.2,2,0.5,2.2,1.5s-0.5,2-1.5,2.2,l-23.3,4.1C39.4,53.5,39.3,53.5,39.2,53.5 z" />
        </g>
    );
}

export function CordedBlindsSVGPath() {
    return (
        <g id="Blinds">
            <path d="M79.8,19.5H3c-1.1,0-2-0.9-2-2v-11c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v9h72.8v-9c-0.2-1.1,0.5-2.1,1.5-2.4c1.1-0.2,2.1,0.5,2.4,1.5c0.1,0.3,0.1,0.6,0,0.8v11C81.7,18.6,80.8,19.4,79.8,19.5z" />
            <path d="M79.8,38.2H3c-1.1,0-2-0.9-2-2v-11c-0.2-1.1,0.5-2.1,1.5-2.4s2.1,0.5,2.4,1.5C5,24.7,5,25,4.9,25.2v9h72.9v-9c-0.2-1.1,0.5-2.1,1.5-2.4c1.1-0.2,2.1,0.5,2.4,1.5c0.1,0.3,0.1,0.6,0,0.8v11C81.7,37.3,80.9,38.2,79.8,38.2z" />
            <path d="M79.8,57H3c-1.1,0-2-0.9-2-2V44c0.2-1.1,1.3-1.8,2.4-1.5c0.8,0.2,1.4,0.8,1.5,1.5v9h72.9v-9c0.2-1.1,1.3-1.8,2.4-1.5c0.8,0.2,1.4,0.8,1.5,1.5v11C81.7,56.1,80.9,57,79.8,57z" />
            <path d="M79.8,75.8H3c-1.1,0-2-0.9-2-2v-11c0.2-1.1,1.3-1.8,2.4-1.5c0.8,0.2,1.4,0.8,1.5,1.5v9h72.9v-9c0.2-1.1,1.3-1.8,2.4-1.5c0.8,0.2,1.4,0.8,1.5,1.5v11C81.7,74.9,80.9,75.8,79.8,75.8z" />
            <path d="M79.8,94.6H3c-1.1,0-2-0.9-2-2v-11c0.2-1.1,1.3-1.8,2.4-1.5c0.8,0.2,1.4,0.8,1.5,1.5v9h72.9v-9c0.2-1.1,1.3-1.8,2.4-1.5c0.8,0.2,1.4,0.8,1.5,1.5v11C81.7,93.7,80.9,94.6,79.8,94.6z" />
            <path d="M93.8,91c-1.1,0-2-0.9-2-2V6.6c-0.2-1.1,0.5-2.1,1.5-2.4c1.1-0.2,2.1,0.5,2.4,1.5c0.1,0.3,0.1,0.6,0,0.8v82.5C95.6,90.1,94.8,91,93.8,91z" />
            <circle className="st0" cx="93.8" cy="90.3" r="4.2" />
        </g>
    );
}

export function SafetySwitchSVGPath() {
    return (
        <g id="SafetySwitch">
            <path d="M75.3,18.4v63.1H24.7V18.4h50.6M77.7,14.9H22.3c-.6,0-1.1.5-1.1,1.1v67.9c0,.6.5,1.1,1.1,1.1h55.4c.6,0,1.1-.5,1.1-1.1V16c0-.6-.5-1.1-1.1-1.1h0Z" />
            <path d="M56.1,31.8v36.2h-11.9V31.8h11.9M58.5,28.3h-16.8c-.6,0-1.1.5-1.1,1.1v41c0,.6.5,1.1,1.1,1.1h16.7c.6,0,1.1-.5,1.1-1.1V29.4c0-.6-.4-1.1-1-1.1h0Z" />
            <g>
                <rect x="36.3" y="46.7" width="27.5" height="6.4" />
                <path d="M62.1,48.4v2.9h-24v-2.9h24M64.6,44.9h-28.9c-.6,0-1.1.5-1.1,1.1v7.7c0,.6.5,1.1,1.1,1.1h28.9c.6,0,1.1-.5,1.1-1.1v-7.7c0-.6-.6-1.1-1.1-1.1h0Z" />
            </g>
            <path d="M50.1,8.1c.9,0,1.7.7,1.7,1.7s-.7,1.7-1.7,1.7-1.7-.7-1.7-1.7.8-1.7,1.7-1.7M50.1,6.1c-2,0-3.7,1.6-3.7,3.7s1.6,3.7,3.7,3.7,3.7-1.6,3.7-3.7-1.7-3.7-3.7-3.7h0Z" />
            <path d="M50.1,88.6c.9,0,1.7.7,1.7,1.7s-.7,1.7-1.7,1.7-1.7-.7-1.7-1.7c0-.9.8-1.7,1.7-1.7M50.1,86.6c-2,0-3.7,1.6-3.7,3.7s1.6,3.7,3.7,3.7,3.7-1.6,3.7-3.7c0-2-1.7-3.7-3.7-3.7h0Z" />
            <path d="M69.4,4.6v10.3H30.8V4.6h38.6M71.8,1.1H28.4c-.6,0-1.1.5-1.1,1.1v15.1c0,.6.5,1.1,1.1,1.1h43.4c.6,0,1.1-.5,1.1-1.1V2.1c0-.5-.5-1-1.1-1h0Z" />
            <path d="M69.4,85.2v10.3H30.8v-10.3h38.6M71.8,81.7H28.4c-.6,0-1.1.5-1.1,1.1v15.1c0,.6.5,1.1,1.1,1.1h43.4c.6,0,1.1-.5,1.1-1.1v-15.2c0-.6-.5-1-1.1-1h0Z" />
        </g>
    );
}

export function WaterEfficiencySVGPath() {
    return (
        <g id="Water">
            <path d="M46.1,99C25.4,99,8.6,82.2,8.6,61.5c0-20.2,34.6-58.4,36.1-60c0.4-0.4,0.9-0.6,1.4-0.6l0,0c0.5,0,1,0.2,1.4,0.6c0.1,0.1,6.2,6.8,13.3,16c0.6,0.8,0.5,2-0.3,2.7c-0.8,0.6-2,0.5-2.7-0.3c-5-6.5-9.5-11.7-11.7-14.2C39.6,13,12.4,45,12.4,61.5c0,18.6,15.1,33.7,33.7,33.7c12.5,0,23.9-6.9,29.8-17.9c0.6-0.9,1.7-1.2,2.6-0.6c0.8,0.5,1.1,1.5,0.7,2.4C72.7,91.3,60,99,46.1,99z" />
            <path d="M69.3,73.3c-12,0-21.7-9.7-21.7-21.7c0-11.5,19.5-33,20.3-33.9c0.7-0.8,2-0.8,2.7,0c0,0,0,0,0,0C71.6,18.6,91,40.1,91,51.7C91,63.6,81.3,73.3,69.3,73.3z M69.3,21.8c-6,6.9-17.9,22.1-17.9,29.8c0,9.9,8,17.9,17.9,17.9s17.9-8,17.9-17.9C87.2,43.9,75.4,28.8,69.3,21.8z" />
        </g>
    );
}

export function OtherServiceSVGPath() {
    return (
        <g
            id="Other"
        >
            <path
                d="M 50.5,98.7 C 23.4,98.7 1.4,76.7 1.4,49.6 1.4,22.5 23.4,0.5 50.5,0.5 c 27.1,0 49.1,22 49.1,49.1 v 0 c -0.1,27.1 -22,49 -49.1,49.1 z m 0,-94.4 c -25,0 -45.3,20.3 -45.3,45.3 0,25 20.3,45.3 45.3,45.3 25,0 45.3,-20.3 45.3,-45.3 0,-25 -20.3,-45.3 -45.3,-45.3 z"
                id="path1"
            />
            <g
                id="g4"
                transform="matrix(5.2159731,0,0,5.2159731,-12.415947,-13.390872)"
                vectorEffect="non-scaling-stroke"
            >
                <path
                    d="M 11.59375,7.4609375 C 10.493832,7.7511585 9.7421862,8.6033187 9.1679688,9.3945313 L 9.8515625,9.890625 C 10.386221,9.1539203 11.020478,8.4852936 11.808594,8.2773438 h 0.002 v -0.00195 c 0.542976,-0.1473296 1.17497,0.095287 1.583984,0.5292969 v 0.00195 c 0.286454,0.3018738 0.366645,0.4906746 0.513672,0.9179688 0.171353,0.6453635 -0.06695,1.4663975 -0.529297,1.8515625 -0.409884,0.328167 -1.137982,0.601928 -1.515625,1.359375 -0.232723,0.449375 -0.222656,0.900425 -0.222656,1.275391 h 0.84375 c 0,-0.379152 0.0086,-0.661257 0.128906,-0.890625 l 0.002,-0.0039 0.002,-0.0039 c 0.202364,-0.407623 0.741941,-0.634806 1.296875,-1.082031 l 0.0039,-0.002 0.002,-0.0039 c 0.772915,-0.643882 1.07089,-1.754676 0.802734,-2.7343745 l -0.0039,-0.013672 -0.0039,-0.013672 C 14.552691,8.9900032 14.378365,8.6175158 14.007813,8.2265625 13.414893,7.5974085 12.49924,7.2170917 11.59375,7.4609375 Z"
                    id="path4"
                    strokeWidth={0.5}

                />

                <path
                    d="m 12.0625,15.509766 c -0.280627,0 -0.511719,0.23353 -0.511719,0.513671 0,0.280142 0.231092,0.513672 0.511719,0.513672 0.280627,0 0.509766,-0.23353 0.509766,-0.513672 0,-0.280141 -0.229139,-0.513671 -0.509766,-0.513671 z m 0,0.408203 c 0.05728,0 0.101562,0.04451 0.101563,0.105468 0,0.06096 -0.04429,0.103516 -0.101563,0.103516 -0.05728,0 -0.101562,-0.04256 -0.101562,-0.103516 0,-0.06096 0.04429,-0.105468 0.101562,-0.105468 z"
                    id="path8"
                    strokeWidth={0.8}

                />
            </g>
        </g>
    );
}

export function MinimumStandardsSVGPath() {
    return (
        <g id="Minimum_Standards">
            <path d="M16.75 19.55h19.08M16.75 28.9h19.08M16.75 38.25h19.08M3.99 5.37h73.08M3.99 94.65h73.08M3.99 93.2V6.24M77.07 30.52V5.84M77.07 94.65V83.88" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="5" />
            <rect width="37.66" height="37.66" x="58.24" y="38.37" fill="none" strokeMiterlimit="10" strokeWidth="5" rx=".82" ry=".82" />
            <path strokeMiterlimit="10" d="M74.15 66.27c-.32 0-.64-.13-.89-.38l-6.5-6.5c-.51-.51-.51-1.34 0-1.78.51-.51 1.34-.51 1.78 0l5.48 5.55 11.47-14.53c.45-.57 1.21-.64 1.78-.19s.64 1.21.19 1.78l-12.3 15.55c-.25.25-.57.45-.96.51h-.06Z" />
        </g>
    );
}

export function MiniumEnergyEfficiencyStandardReadinessCheckSVGPath() {
    return (
        <g id="MinimumEnergyEfficiencyStandardReadinessCheck">
            <path
                d="M80.49,41.77l4.05,12.47h13.12c.27,0,.39.35.17.51l-10.61,7.71,4.05,12.47c.08.26-.21.47-.43.31l-10.61-7.71-10.61,7.71c-.22.16-.52-.06-.43-.31l4.05-12.47-10.61-7.71c-.22-.16-.11-.51.17-.51h13.12l4.05-12.47c.08-.26.44-.26.52,0,0,0,0,0,0,0Z"
                style={{
                    strokeWidth: '3px', strokeMiterlimit: 10,
                }}
            />
            <line
                x1="4.09"
                y1="3.7"
                x2="80.22"
                y2="3.7"
                style={{
                    strokeLinecap: 'round', strokeWidth: '4px', strokeMiterlimit: 10, fill: 'none',
                }}
            />
            <line
                x1="4.09"
                y1="95.2"
                x2="4.09"
                y2="4.62"
                style={{
                    strokeLinecap: 'round', strokeWidth: '4px', strokeMiterlimit: 10, fill: 'none',
                }}
            />
            <line
                x1="80.22"
                y1="29.9"
                x2="80.22"
                y2="4.19"
                style={{
                    strokeLinecap: 'round', strokeWidth: '4px', strokeMiterlimit: 10, fill: 'none',
                }}
            />
            <line
                x1="80.22"
                y1="96.71"
                x2="80.22"
                y2="85.49"
                style={{
                    strokeLinecap: 'round', strokeWidth: '4px', strokeMiterlimit: 10, fill: 'none',
                }}
            />
            <line
                x1="4.09"
                y1="96.71"
                x2="80.22"
                y2="96.71"
                style={{
                    strokeLinecap: 'round', strokeWidth: '4px', strokeMiterlimit: 10, fill: 'none',
                }}
            />
            <path
                d="M32.8,12.98c.52.52.52,1.36,0,1.88l-10.6,10.6c-.52.52-1.36.52-1.88,0l-5.3-5.3c-.52-.52-.52-1.36,0-1.88s1.36-.52,1.88,0l4.36,4.36,9.66-9.66c.52-.52,1.36-.52,1.88,0h0Z"
                style={{
                    strokeWidth: '0.5px', strokeMiterlimit: 10,
                }}
            />
            <path
                d="M32.8,26.63c.52.52.52,1.36,0,1.88l-10.6,10.6c-.52.52-1.36.52-1.88,0l-5.3-5.3c-.52-.52-.52-1.36,0-1.88s1.36-.52,1.88,0l4.36,4.36,9.66-9.66c.52-.52,1.36-.52,1.88,0h0Z"
                style={{
                    strokeWidth: '0.5px', strokeMiterlimit: 10,
                }}
            />
            <path
                d="M32.8,40.3c.52.52.52,1.36,0,1.88l-10.6,10.6c-.52.52-1.36.52-1.88,0l-5.3-5.3c-.52-.52-.52-1.36,0-1.88s1.36-.52,1.88,0l4.36,4.36,9.66-9.66c.52-.52,1.36-.52,1.88,0h0Z"
                style={{
                    strokeWidth: '0.5px', strokeMiterlimit: 10,
                }}
            />
        </g>
    );
}
